import { Routes } from '@angular/router';
import { BEZUGSRECHT_ROUTES } from '@zero/bezugsrecht/domain';
import { provideTradeDomain } from '@zero/trade/domain';

export const BEZUGSRECHT_WEB_ROUTES: Routes = [
  {
    path: '',
    loadComponent: () => import('./bezugsrecht-page-web.component').then((m) => m.BezugsrechtPageWebComponent),
  },
  {
    path: ':id',
    loadComponent: () => import('./bezugsrecht-page-web.component').then((m) => m.BezugsrechtPageWebComponent),
    children: [
      {
        path: '',
        loadComponent: () => import('./components/home/bezugsrecht-home.component').then((m) => m.BezugsrechtHomeComponent),
      },
      {
        path: BEZUGSRECHT_ROUTES.BUY,
        loadComponent: () => import('./components/buy/bezugsrecht-buy.component').then((m) => m.BezugsrechtBuyComponent),
        providers: [provideTradeDomain()],
      },
      {
        path: BEZUGSRECHT_ROUTES.SELL,
        loadComponent: () => import('./components/sell/bezugsrecht-sell.component').then((m) => m.BezugsrechtSellComponent),
      },
      {
        path: BEZUGSRECHT_ROUTES.BUY_CUSTOM,
        providers: [provideTradeDomain()],
        loadComponent: () =>
          import('./components/buy-custom/bezugsrecht-buy-custom.component').then((m) => m.BezugsrechtBuyCustomComponent),
      },
      {
        path: BEZUGSRECHT_ROUTES.SUMMARY,
        loadComponent: () => import('./components/summary/bezugsrecht-summary.component').then((m) => m.BezugsrechtSummaryComponent),
      },
      {
        path: BEZUGSRECHT_ROUTES.SUCCESS,
        loadComponent: () => import('./components/success/bezugsrecht-success.component').then((m) => m.BezugsrechtSuccessComponent),
      },
    ],
  },
];
